import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Text from '../../atoms/Text';

import styles from './BackHeader.module.scss';
import usePresenter from './BackHeader.presenter';
import getProps from './BackHeader.props';
import { BackHeaderCombinedProps } from './types';

const BackHeader: React.FC<BackHeaderCombinedProps> = (props) => {
  const {
    className,
    classes,
    button,
    text,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.backHeader;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.headerContent, classes?.headerContent)}>
        <Button
          className={cx(styles.button, classes?.button)}
          {...internalProps.button}
          {...button}
        />
        <Text
          className={cx(styles.text, classes?.text)}
          {...internalProps.text}
          {...text}
        />
      </div>
    </div>
  );
};

export default BackHeader;
